import React from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames';

const Item = ({ className, children }) => {
    const classWrapper = classNames('col-12-xs', 'col-6-sm', 'col-4-md', 'col-3-lg', className);

    return <div className={classWrapper}>{children}</div>;
};

Item.propTypes = {
    className: string,
    children: node,
};

export default Item;
